<div class="my-3 my-md-5">
          <div class="container">
            <div class="page-header">
              <h1 class="page-title" *ngIf="myrole!='14'">
                Dashboard
              </h1>
              <h1 class="page-title" *ngIf="mark_as_affiliate=='1'">
                <button  type="submit" class="btn btn-primary" routerLink="/create-affiliate-user">
                  ADD AFFILIATE  
              </button>
              </h1>
            </div>
            <!-- For inssurance user -->
            <div class="row row-cards" *ngIf="myrole=='5'">
                <div class="col-6 col-sm-4 col-lg-2">
                    <div class="card">
                        <div class="card-body p-3 text-center">
                            <div class="h1 m-0 text-success"><i  *ngIf="loadingI" class="fas fa-spin fa-spinner"></i> {{InsuranceCount.todayCount}}</div>
                            <div class="text-primary mb-4">Today's Entries</div>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-2">
                    <div class="card">
                        <div class="card-body p-3 text-center">
                            <div class="h1 m-0 text-success"><i  *ngIf="loadingI" class="fas fa-spin fa-spinner"></i> {{InsuranceCount.monthCount}}</div>
                            <div class="text-primary mb-4">This Month's Entries</div>
                        </div>
                    </div>
                </div>
                  <div class="col-6 col-sm-4 col-lg-2">
                    <div class="card">
                        <div class="card-body p-3 text-center">
                            <div class="h1 m-0 text-success"><i  *ngIf="loadingTat" class="fas fa-spin fa-spinner"></i>
                              {{insuranceReport.pending}}
                            </div>
                            <div class="text-primary mb-4">Your's Pending</div>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-2">
                  <div class="card">
                      <div class="card-body p-3 text-center">
                          <div class="h1 m-0 text-success"><i  *ngIf="loadingTat" class="fas fa-spin fa-spinner"></i>
                            {{insuranceReport.approved}}
                          </div>
                          <div class="text-primary mb-4">Your's Approved</div>
                      </div>
                  </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-2">
                  <div class="card">
                      <div class="card-body p-3 text-center">
                          <div class="h1 m-0 text-danger"><i  *ngIf="loadingTat" class="fas fa-spin fa-spinner"></i>
                            {{insuranceReport.rejected}}
                          </div>
                          <div class="text-primary mb-4">Your's Rejected</div>
                      </div>
                  </div>
              </div>
                <div class="col-6 col-sm-4 col-lg-2">
                    <div class="card">
                        <div class="card-body p-3 text-center">
                            <div class="h1 m-0 text-success"><i  *ngIf="loadingI" class="fas fa-spin fa-spinner"></i> {{InsuranceCount.totalCount}}</div>
                            <div class="text-primary mb-4">Total Entries</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row row-cards" *ngIf="myrole=='5'">
              <!-- <div class="col-6 col-sm-4 col-lg-3">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Pre Auth</div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Pending : <span class="text-success" *ngIf="insuranceReport.pre_auth_pending">{{insuranceReport.pre_auth_pending}}</span><span class="text-success" *ngIf="!insuranceReport.pre_auth_pending">0</span></div>
                    <div class="mb-1 text-left font-weight500"> Query: <span class="text-success" *ngIf="insuranceReport.pre_auth_query">{{insuranceReport.pre_auth_query}}</span><span class="text-success" *ngIf="!insuranceReport.pre_auth_query">0</span></div>
                    <div class="mb-1  text-left font-weight500"> Approve: <span class="text-success" *ngIf="insuranceReport.pre_auth_approved">{{insuranceReport.pre_auth_approved}}</span><span class="text-success" *ngIf="!insuranceReport.pre_auth_approved">0</span></div>
                  </div>
                </div>
              </div>

              <div class="col-6 col-sm-4 col-lg-3">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Pre Approval</div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Pending : <span class="text-success" *ngIf="insuranceReport.pre_approval_pending">{{insuranceReport.pre_approval_pending}}</span><span class="text-success" *ngIf="!insuranceReport.pre_approval_pending">0</span></div>
                    <div class="mb-1 text-left font-weight500"> Query: <span class="text-success" *ngIf="insuranceReport.pre_approval_query">{{insuranceReport.pre_approval_query}}</span><span class="text-success" *ngIf="!insuranceReport.pre_approval_query">0</span></div>
                    <div class="mb-1  text-left font-weight500"> Approve: <span class="text-success" *ngIf="insuranceReport.pre_approval_approved">{{insuranceReport.pre_approval_approved}}</span><span class="text-success" *ngIf="!insuranceReport.pre_approval_approved">0</span></div>
                  </div>
                </div>
              </div>

              <div class="col-6 col-sm-4 col-lg-3">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Final Approval</div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Pending : <span class="text-success" *ngIf="insuranceReport.final_approval_pending">{{insuranceReport.final_approval_pending}}</span><span class="text-success" *ngIf="!insuranceReport.final_approval_pending">0</span></div>
                    <div class="mb-1 text-left font-weight500"> Query: <span class="text-success" *ngIf="insuranceReport.final_approval_query">{{insuranceReport.final_approval_query}}</span><span class="text-success" *ngIf="!insuranceReport.final_approval_query">0</span></div>
                    <div class="mb-1  text-left font-weight500"> Approve: <span class="text-success" *ngIf="insuranceReport.final_approval_approved">{{insuranceReport.final_approval_approved}}</span><span class="text-success" *ngIf="!insuranceReport.final_approval_approved">0</span></div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="col-6 col-sm-4 col-lg-3">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="align-items-center">
                       <div class="subheader text-primary">Last Month Billed Amount</div>
                    </div>
                    <div class="text-center" style="margin-top: 20px; font-size: 28px;"><i  *ngIf="loadingI" class="fas fa-spin fa-spinner"></i>{{InsuranceLastMonthCasesBilledAmount | currency :'INR'}}</div>
                  </div>
                </div>
              </div> -->
              
              <div class="col-6 col-sm-4 col-lg-3">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="align-items-center">
                       <div class="subheader text-primary">This Month Billed Amount</div>
                    </div>
                    <div class="text-center" style="margin-top: 20px; font-size: 28px;"><i  *ngIf="loadingI" class="fas fa-spin fa-spinner"></i>{{InsuranceCasesBilledAmount | currency :'INR'}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-cards" *ngIf="myrole=='5'">
                <div class="col-sm-12">
                  <h2>Status History of Insurance Records</h2>
                </div>
                <div class="col-md-3" *ngIf="insFilterRev=='overall'">
                  <div >
                    <mat-form-field appearance="fill">
                        <mat-label>Enter a date range</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate #dateRangeStart5 placeholder="Start date">
                            <input matEndDate #dateRangeEnd5 placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart5, dateRangeEnd5,5)">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                    <mat-icon class="insurance_tat_clear" (click)="clearDate(5)">clear</mat-icon>
                  </div>
              </div>
              <div class="col-md-3">
                <mat-select  [(ngModel)]="insFilterRev" (selectionChange)="getInsuranceReportofPreAuthApprovalFinal()">
                    <mat-option value="today">Today</mat-option>
                    <mat-option value="overall">Overall</mat-option>
                    <mat-option value="prevmonth">Previous Month</mat-option>
                    <mat-option value="month">This Month</mat-option>
                </mat-select>
                </div>
                
              <div class="col-12 col-sm-12 col-lg-12 mt-5">
                <div class="card">
                  <div class="table-responsive">
                      <table class="table table-hover table-bordered table-vcenter text-nowrap card-table">
                          <thead>
                            <!-- <tr class="text-center">
                                <th colspan="12" class="text-center">Today's Data</th>
                            </tr> -->
                            <tr class="text-center">
                              <th class="thstyle"></th>
                              <th class="thstyle"></th>
                              <th class="thstyle"></th>
                              <th class="thstyle"></th>
                              <th class="thstyle"></th>
                              <th class="thstyle"></th>
                              <th class="thstyle" colspan = "2">Pre Approval</th>
                              <th class="thstyle" colspan = "2">Final Approval</th>
                            </tr>
                            <tr class="text-center">
                              <th class="text-center w-1"><i class="icon-people"></i></th>
                              <th class="thstyle">User</th>
                              <th class="thstyle">Pending</th>
                              <th class="thstyle">Approved</th>
                              <th class="thstyle">Rejected</th>
                              <th class="thstyle">Pre Auth Pending</th>
                              <th class="thstyle">Pending</th>
                              <th class="thstyle">Approved</th>
                              <th class="thstyle">Pending</th>
                              <th class="thstyle">Approved</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr  *ngFor="let hreport of insuranceHistoryReport" class="text-center" >
                                  <td>
                                    <div class="avatar d-block avatar-md" style="background-image: url('assets/images/defalutpic.png')">
                                    </div>
                                  </td>
                                  <td>{{hreport.name}}</td>
                                  <td>{{hreport.total_data[0]['pending']}}</td>
                                  <td>{{hreport.total_data[0]['approved']}}</td>
                                  <td>{{hreport.total_data[0]['rejected']}}</td>
                                  <td>{{hreport.total_data[0]['pre_auth_pending_total']}}</td>
                                  <td>{{hreport.total_data[0]['pre_approval_pending_total']}}</td>
                                  <td>{{hreport.total_data[0]['pre_approval_approved_total']}}</td>
                                  <td>{{hreport.total_data[0]['final_approval_pending_total']}}</td>
                                  <td>{{hreport.total_data[0]['final_approval_approved_total']}}</td> 
                              </tr>
                              <tr class="text-center" >
                                <td></td>
                                <td class="thstyle">Total</td>
                                 <td class="thstyle">{{insuranceHistoryReportTotal['total_pending']}}</td>
                                <td class="thstyle">{{insuranceHistoryReportTotal['total_approved']}}</td>
                                <td class="thstyle">{{insuranceHistoryReportTotal['total_rejected']}}</td>
                                <td class="thstyle">{{insuranceHistoryReportTotal['total_preauth_pending']}}</td>
                                <td class="thstyle">{{insuranceHistoryReportTotal['total_preapproval_pending']}}</td>
                                <td class="thstyle">{{insuranceHistoryReportTotal['total_preapproval_approved']}}</td>
                                <td class="thstyle">{{insuranceHistoryReportTotal['total_finalapproval_pending']}}</td>
                                <td class="thstyle">{{insuranceHistoryReportTotal['total_finalapproval_approved']}}</td> 
                            </tr>
                              <tr *ngIf="loadinghistyoryTat">
                                  <td colspan="12" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Insurance User dashboard -->
            

              <!-- For BDs and Admin -->
            <div class="row row-cards" *ngIf="myrole=='3' || myrole=='1' || myrole=='7'|| myrole=='15' ; else otherRoles">
              <div class="col-6 col-sm-4 col-lg-3" *ngIf="treatment_catergory_access!='4'">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Today's Appointments</div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> OPD : <span class="text-success">{{todayAppointmentCount.opd}} opds</span></div>
                    <div class="mb-1 text-left font-weight500"> IPD Admission: <span class="text-success">{{todayAppointmentCount.ipdAddmission}} ipds</span></div>
                    <div class="mb-1  text-left font-weight500"> IPD Discharge: <span class="text-success">{{todayAppointmentCount.ipdDischarge}} ipds</span></div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-sm-4 col-lg-3" *ngIf="treatment_catergory_access!='4'">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                     <div class="d-flex align-items-center">
                        <div class="subheader text-primary">Completed Appointments</div>
                      </div>
                      <div class="mb-1 mt-2 text-left font-weight500">  OPD : <span class="text-success">{{completedAppointments.total_Opds}} opds </span> </div>
                      <div class="mb-3 text-left font-weight500"> IPD : <span class="text-success">{{completedAppointments.total_Ipds}} ipds </span> </div>

                  </div>
                </div>
              </div>
             <div class="col-6 col-sm-4 col-lg-3" *ngIf="treatment_catergory_access!='4'">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                     <div class="d-flex align-items-center">
                        <div class="subheader text-primary">Cancelled Appointments</div>
                      </div>
                      <div class="mb-1 mt-2 text-left font-weight500">  OPD : <span class="text-success">{{cancelledAppointments.total_Opds}} opds </span> </div>
                      <div class="mb-3 text-left font-weight500"> IPD : <span class="text-success">{{cancelledAppointments.total_Ipds}} ipds </span> </div>

                  </div>
                </div>
              </div>

              <div class="col-6 col-sm-4 col-lg-3" *ngIf="treatment_catergory_access!='4'">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Active Users</div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Total Users : <span class="text-success">{{ActiveUsers.activeUsers}} Users</span></div>
                    <div class="mb-1 text-left font-weight500"> Total Doctors: <span class="text-success">{{ActiveUsers.activeDoctors}} Doctors</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Hospitals: <span class="text-success">{{ActiveUsers.activeHospitals}} Hospitals</span></div>
                  </div>
                </div>
              </div>
            </div>
             <ng-template #otherRoles>
                  <div class="row row-cards" *ngIf="myrole=='2'">
                  <div class="col-6 col-sm-4 col-lg-3" *ngIf="treatment_catergory_access!='4'">
                    <div class="card flex_class">
                      <div class="card-body p-3 text-center">
                        <div class="d-flex align-items-center">
                           <div class="subheader text-primary">Today's Appointments</div>
                        </div>
                        <div class="mb-1 mt-2 text-left font-weight500"> OPD : <span class="text-success">{{todayAppointmentCount.opd}} opds</span></div>
                        <div class="mb-1 text-left font-weight500"> IPD Admission: <span class="text-success">{{todayAppointmentCount.ipdAddmission}} ipds</span></div>
                        <div class="mb-1  text-left font-weight500"> IPD Discharge: <span class="text-success">{{todayAppointmentCount.ipdDischarge}} ipds</span></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-sm-4 col-lg-3" *ngIf="treatment_catergory_access!='4'">
                    <div class="card flex_class">
                      <div class="card-body p-3 text-center">
                         <div class="d-flex align-items-center">
                           <div class="subheader text-primary">Cases</div>
                            <div class="subheader text-primary ml-auto lh-1">This Month</div>
                          </div>
                          <div class="mb-1 mt-2 text-left font-weight500">  OPDs : <span class="text-success">{{currentMonthcount.opd}} opds </span> </div>
                          <div class="mb-3 text-left font-weight500"> IPDs : <span class="text-success">{{currentMonthcount.ipdAddmission}} ipds </span> </div>

                      </div>
                    </div>
                  </div>
                 <div class="col-6 col-sm-4 col-lg-3" *ngIf="treatment_catergory_access!='4'">
                    <div class="card flex_class">
                      <div class="card-body p-3 text-center">
                         <div class="d-flex align-items-center">
                            <div class="subheader text-primary">Cases</div>
                            <div class="subheader text-primary ml-auto lh-1">Previous Month</div>
                          </div>
                          <div class="mb-1 mt-2 text-left font-weight500">  OPDs : <span class="text-success">{{previousMonthcount.opd}} opds </span> </div>
                          <div class="mb-3 text-left font-weight500"> IPDs : <span class="text-success">{{previousMonthcount.ipdAddmission}} ipds </span> </div>

                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-sm-4 col-lg-3" *ngIf="treatment_catergory_access!='4'">
                    <div class="card flex_class">
                      <div class="card-body p-3 text-center">
                         <div class="d-flex align-items-center">
                            <div class="subheader text-primary">Cases</div>
                            <div class="subheader text-primary ml-auto lh-1">Till Date</div>
                          </div>
                          <div class="mb-1 mt-2 text-left font-weight500">  OPDs : <span class="text-success">{{totalcount.opd}} opds </span> </div>
                          <div class="mb-3 text-left font-weight500"> IPDs : <span class="text-success">{{totalcount.ipdAddmission}} ipds </span> </div>

                      </div>
                    </div>
                  </div>

                </div>
              </ng-template>

              <div class="row row-cards" *ngIf="myrole=='1' || (myrole=='4' && cm_access=='1')">
                <div class="col-6 col-sm-6 col-lg-6">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                      <div class="d-flex align-items-center">
                         <div class="subheader text-primary">OPD Feedbacks</div>
                      </div>
                      <div class="col-sm-12 pl-0 pr-0 float-left">
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Total : <span class="text-success">{{OpdFeedBackCount.totalopd}} opds</span></div>
                        </div>
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Active: <span class="text-success"> {{OpdFeedBackCount.activeOpdFeedback}} feedbacks</span></div>
                        </div>
                      </div>
                      <div class="col-sm-12 pl-0 pr-0 float-left">
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Pending-1 : <span class="text-success">{{OpdFeedBackCount.followup1_OpdFeedback}} feedbacks</span></div>
                        </div>
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Pending-2: <span class="text-success"> {{OpdFeedBackCount.followup2_OpdFeedback}} feedbacks</span></div>
                        </div>
                      </div>
                      <div class="col-sm-12 pl-0 pr-0 float-left">
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Not Received : <span class="text-success">{{OpdFeedBackCount.notReceivedOpdFeedback}} feedbacks</span></div>
                        </div>
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Completed: <span class="text-success"> {{OpdFeedBackCount.completedOpdFeedback}} feedbacks</span></div>
                        </div>
                        <!-- <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Pending : <span class="text-success">{{getPendingFeedBack(OpdFeedBackCount,'1')}} feedbacks</span></div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-sm-6 col-lg-6">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                      <div class="d-flex align-items-center">
                         <div class="subheader text-primary">IPD Feedbacks</div>
                      </div>
                      <div class="col-sm-12 pl-0 pr-0 float-left">
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Total : <span class="text-success">{{IpdFeedBackCount.totalipd}} ipds</span></div>
                        </div>
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Active: <span class="text-success"> {{IpdFeedBackCount.activeIpdFeedback}} feedbacks</span></div>
                        </div>
                      </div>
                      <div class="col-sm-12 pl-0 pr-0 float-left">
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Pending-1 : <span class="text-success">{{IpdFeedBackCount.followup1_IpdFeedback}} feedbacks</span></div>
                        </div>
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Pending-2: <span class="text-success"> {{IpdFeedBackCount.followup2_IpdFeedback}} feedbacks</span></div>
                        </div>
                      </div>
                      <div class="col-sm-12 pl-0 pr-0 float-left">
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Not Received : <span class="text-success">{{IpdFeedBackCount.notReceivedIpdFeedback}} feedbacks</span></div>
                        </div>
                        <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Completed: <span class="text-success"> {{IpdFeedBackCount.completedIpdFeedback}} feedbacks</span></div>
                        </div>
                        <!-- <div class="col-sm-6 float-left pl-0 pr-0">
                          <div class="mb-1 mt-2 text-left font-weight500"> Pending : <span class="text-success">{{getPendingFeedBack(IpdFeedBackCount,'2')}} feedbacks</span></div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row row-cards" *ngIf="myrole=='8' || myrole=='10'">
                <div class="col-6 col-sm-4 col-lg-3">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                      <div class="d-flex align-items-center">
                         <div class="subheader text-primary">Today Cab Details</div>
                      </div>
                      <div class="mb-1 mt-2 text-left font-weight500"> Pending : <span class="text-success" *ngIf="todayCabReport.pending">{{todayCabReport.pending}} cabs</span><span class="text-success" *ngIf="!todayCabReport.pending">0</span></div>
                      <div class="mb-1 text-left font-weight500"> Booked: <span class="text-success" *ngIf="todayCabReport.booked">{{todayCabReport.booked}} cabs</span><span class="text-success" *ngIf="!todayCabReport.booked">0</span></div>
                      <div class="mb-1  text-left font-weight500"> Cancelled: <span class="text-success" *ngIf="todayCabReport.cancelled">{{todayCabReport.cancelled}} cabs</span><span class="text-success" *ngIf="!todayCabReport.cancelled">0</span></div>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-sm-4 col-lg-3">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                      <div class="d-flex align-items-center">
                         <div class="subheader text-primary">Tomorrow Cab Details</div>
                      </div>
                      <div class="mb-1 mt-2 text-left font-weight500"> Pending : <span class="text-success" *ngIf="tomorrowCabReport.pending">{{tomorrowCabReport.pending}} cabs</span><span class="text-success" *ngIf="!tomorrowCabReport.pending">0</span></div>
                      <div class="mb-1 text-left font-weight500"> Booked: <span class="text-success" *ngIf="tomorrowCabReport.booked">{{tomorrowCabReport.booked}} cabs</span><span class="text-success" *ngIf="!tomorrowCabReport.booked">0</span></div>
                      <div class="mb-1  text-left font-weight500"> Cancelled: <span class="text-success" *ngIf="tomorrowCabReport.cancelled">{{tomorrowCabReport.cancelled}} cabs</span><span class="text-success" *ngIf="!tomorrowCabReport.cancelled">0</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <!---------For Docknee User-------------------------->
              <div class="row row-cards" *ngIf="myrole=='13'">
                <div class="col-6 col-sm-4 col-lg-3">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                      <div class="d-flex align-items-center">
                         <div class="subheader text-primary">Today's Appointments</div>
                      </div>
                      <div class="mb-1 mt-2 text-left font-weight500"> OPD : <span class="text-success">{{todayAppointmentCount.opd}} opds</span></div>
                      <div class="mb-1 text-left font-weight500"> IPD Admission: <span class="text-success">{{todayAppointmentCount.ipdAddmission}} ipds</span></div>
                      <div class="mb-1  text-left font-weight500"> IPD Discharge: <span class="text-success">{{todayAppointmentCount.ipdDischarge}} ipds</span></div>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-3">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                       <div class="d-flex align-items-center">
                          <div class="subheader text-primary">Completed Appointments</div>
                        </div>
                        <div class="mb-1 mt-2 text-left font-weight500">  OPD : <span class="text-success">{{completedAppointments.total_Opds}} opds </span> </div>
                        <div class="mb-3 text-left font-weight500"> IPD : <span class="text-success">{{completedAppointments.total_Ipds}} ipds </span> </div>
  
                    </div>
                  </div>
                </div>
               <div class="col-6 col-sm-4 col-lg-3">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                       <div class="d-flex align-items-center">
                          <div class="subheader text-primary">Cancelled Appointments</div>
                        </div>
                        <div class="mb-1 mt-2 text-left font-weight500">  OPD : <span class="text-success">{{cancelledAppointments.total_Opds}} opds </span> </div>
                        <div class="mb-3 text-left font-weight500"> IPD : <span class="text-success">{{cancelledAppointments.total_Ipds}} ipds </span> </div>
  
                    </div>
                  </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-3">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                      <div class="d-flex align-items-center">
                         <div class="subheader text-primary">Lead Summary <i  *ngIf="loading" class="fas fa-spin fa-spinner"></i></div>
                      </div>
                      <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todayCount}}</span></div>
                      <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthCount}}</span></div>
                      <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalCount}}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <!---------For Docknee User-------------------------->

            <div class="row row-cards" *ngIf="myrole=='3' || myrole=='1' || myrole=='2' || myrole=='6' || myrole=='7' || myrole=='15' || myrole=='18'">
                <div class="col-6 col-sm-4 col-lg-3">
                    <div class="card flex_class">
                      <div class="card-body p-3 text-center">
                        <div class="d-flex align-items-center">
                           <div class="subheader text-primary">Lead Summary <i  *ngIf="loading" class="fas fa-spin fa-spinner"></i></div>
                        </div>
                        <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todayCount}}</span></div>
                        <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthCount}}</span></div>
                        <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalCount}}</span></div>
                      </div>
                    </div>
                </div>
                <!-- <div class="col-6 col-sm-4 col-lg-3" *ngIf="treatment_catergory_access!='4'">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                       <div class="d-flex align-items-center">
                         <div class="subheader text-primary">Incentive</div>
                          <div class="subheader text-primary ml-auto lh-1">This Month</div>
                        </div>
                        <div class="mb-3 text-left font-weight500"> Cash IPDs : <span class="text-success">{{currentMonthcount.cashipdAddmission}} ipds * 100 = ({{currentMonthcount.cashipdAddmission*100}})</span> </div>

                    </div>
                  </div>
                </div> -->
                <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='6' || myrole=='18'">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                      <div class="d-flex align-items-center">
                         <div class="subheader text-primary">Today's Appointments</div>
                      </div>
                      <div class="mb-1 mt-2 text-left font-weight500"> OPD : <span class="text-success">{{todayAppointmentCount.opd}} opds</span></div>
                      <div class="mb-1 text-left font-weight500"> IPD Admission: <span class="text-success">{{todayAppointmentCount.ipdAddmission}} ipds</span></div>
                      <div class="mb-1  text-left font-weight500"> IPD Discharge: <span class="text-success">{{todayAppointmentCount.ipdDischarge}} ipds</span></div>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='1' || treatment_catergory_access=='4'">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                      <div class="d-flex align-items-center">
                        <div class="subheader text-primary">Total Dental Lead Summary <i  *ngIf="dental_loading" class="fas fa-spin fa-spinner"></i></div>
                      </div>
                      <div class="mb-1 mt-2 text-left font-weight500">Today's Leads : <span class="text-success">{{todayDentalCount}}</span></div>
                      <div class="mb-1 text-left font-weight500">This Month Leads : <span class="text-success">{{monthDentalCount}}</span></div>
                      <div class="mb-1  text-left font-weight500">Total Leads : <span class="text-success">{{totalDentalCount}}</span></div>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='1' || treatment_catergory_access=='4'">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                      <div class="d-flex align-items-center">
                        <div class="subheader text-primary">Total Dental Appointments <i  *ngIf="dental_loading" class="fas fa-spin fa-spinner"></i></div>
                      </div>
                      <div class="mb-1 mt-2 text-left font-weight500">Total Scan Booked : <span class="text-success">{{full_total_scan_booked}}</span></div>
                      <div class="mb-1 text-left font-weight500">Total Scan Done: <span class="text-success">{{full_total_scan_done}}</span></div>
                      <div class="mb-1  text-left font-weight500">Total Conversion: <span class="text-success">{{full_total_conversation}}</span></div>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='1' || treatment_catergory_access=='4'">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                      <div class="d-flex align-items-center">
                        <div class="subheader text-primary">Today's Dental Appointments <i  *ngIf="dental_loading" class="fas fa-spin fa-spinner"></i></div>
                      </div>
                      <div class="mb-1 mt-2 text-left font-weight500">Today Scan Booked : <span class="text-success">{{total_scan_booked}}</span></div>
                      <div class="mb-1 text-left font-weight500">Today Scan Done: <span class="text-success">{{total_scan_done}}</span></div>
                      <div class="mb-1  text-left font-weight500">Today Conversion: <span class="text-success">{{total_conversation}}</span></div>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='3' &&treatment_catergory_access=='4'">
                  <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                      <div class="d-flex align-items-center">
                         <div class="subheader text-primary">Active Users</div>
                      </div>
                      <div class="mb-1 mt-2 text-left font-weight500"> Total Users : <span class="text-success">{{ActiveUsers.activeUsers}} Users</span></div>
                      <div class="mb-1 text-left font-weight500"> Total Doctors: <span class="text-success">{{ActiveUsers.activeDoctors}} Doctors</span></div>
                      <div class="mb-1  text-left font-weight500"> Total Hospitals: <span class="text-success">{{ActiveUsers.activeHospitals}} Hospitals</span></div>
                    </div>
                  </div>
                </div>
            </div>

            <!-------For Admin & Corporate BDs ------------>
            <div class="row row-cards" style="display: none;">
              <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='1' || (myrole=='14' && loginUserId != '309')">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Corporate Lead Summary <i  *ngIf="cor_ret_loading" class="fas fa-spin fa-spinner"></i></div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todayCorporateCount}}</span></div>
                    <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthCorporateCount}}</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalCorporateCount}}</span></div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='1' || (myrole=='14' && loginUserId != '309')">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Retail Lead Summary <i  *ngIf="cor_ret_loading" class="fas fa-spin fa-spinner"></i></div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todayRetailCount}}</span></div>
                    <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthRetailCount}}</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalRetailCount}}</span></div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='1' || myrole=='14'">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Partner Lead Summary <i  *ngIf="cor_ret_loading" class="fas fa-spin fa-spinner"></i></div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todayPartnerLeadCount}}</span></div>
                    <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthPartnerLeadCount}}</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalPartnerLeadCount}}</span></div>
                  </div>
                </div>
              </div>
              <!-------------Only For Corporate BDs------------>
              <div class="col-6 col-sm-4 col-lg-3" *ngIf="(myrole=='14' && loginUserId != '309')">

              </div>
              <div class="col-6 col-sm-4 col-lg-3" *ngIf="((myrole=='14' && cm_access == '1'))">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">True Cover Lead Summary <i  *ngIf="cor_ret_partner_loading" class="fas fa-spin fa-spinner"></i></div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todaytruecoverLeadCount}}</span></div>
                    <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthtruecoverLeadCount}}</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totaltruecoverLeadCount}}</span></div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-sm-4 col-lg-3" *ngIf="((myrole=='14' && cm_access == '1'))">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Medibuddy Lead Summary <i  *ngIf="cor_ret_partner_loading" class="fas fa-spin fa-spinner"></i></div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todaymedibuddyLeadCount}}</span></div>
                    <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthmedibuddyLeadCount}}</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalmedibuddyLeadCount}}</span></div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='14' && cm_access == '1'">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Affinity Referral Lead Summary <i  *ngIf="cor_ret_partner_loading" class="fas fa-spin fa-spinner"></i></div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todayaffinityrefferalLeadCount}}</span></div>
                    <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthaffinityrefferalLeadCount}}</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalaffinityrefferalLeadCount}}</span></div>
                  </div>
                </div>
              </div>

              <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='14' && cm_access == '1'">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Secure Now Lead Summary <i  *ngIf="cor_ret_partner_loading" class="fas fa-spin fa-spinner"></i></div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todaysecureNowLeadCount}}</span></div>
                    <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthsecureNowLeadCount}}</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalsecureNowLeadCount}}</span></div>
                  </div>
                </div>
              </div>

              <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='14' && cm_access == '1'">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Healthy Sure Lead Summary <i  *ngIf="cor_ret_partner_loading" class="fas fa-spin fa-spinner"></i></div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todayHealthySureLeadCount}}</span></div>
                    <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthHealthySureLeadCount}}</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalHealthySureLeadCount}}</span></div>
                  </div>
                </div>
              </div>

              <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='14' && cm_access == '1'">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Truventiv Lead Summary <i  *ngIf="cor_ret_partner_loading" class="fas fa-spin fa-spinner"></i></div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todayTruventivLeadCount}}</span></div>
                    <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthTruventivLeadCount}}</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalTruventivLeadCount}}</span></div>
                  </div>
                </div>
              </div>

              <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='14' && cm_access == '1'">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Watchful Eye Lead Summary <i  *ngIf="cor_ret_partner_loading" class="fas fa-spin fa-spinner"></i></div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todayWatchfuleyeLeadCount}}</span></div>
                    <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthWatchfuleyeLeadCount}}</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalWatchfuleyeLeadCount}}</span></div>
                  </div>
                </div>
              </div>

               <!----------For Glamyo Partner Dashboard------------->
              <div class="col-6 col-sm-4 col-lg-3" *ngIf="(myrole=='16')">
                <div class="card flex_class">
                  <div class="card-body p-3 text-center">
                    <div class="d-flex align-items-center">
                       <div class="subheader text-primary">Lead Summary <i  *ngIf="cor_ret_partner_loading" class="fas fa-spin fa-spinner"></i></div>
                    </div>
                    <div class="mb-1 mt-2 text-left font-weight500"> Today's Leads : <span class="text-success">{{todaypartnerpLeadCount}}</span></div>
                    <div class="mb-1 text-left font-weight500"> This Month Leads : <span class="text-success">{{monthpartnerpLeadCount}}</span></div>
                    <div class="mb-1  text-left font-weight500"> Total Leads: <span class="text-success">{{totalpartnerpLeadCount}}</span></div>
                  </div>
                </div>
              </div>
               <!----------For Glamyo Partner Dashboard------------->
            </div>
            <!-------For Admin & Corporate BDs ------------>

            <!-------For Corporate BDs ------------>
            <div class="row row-cards mt-2" *ngIf="myrole=='14'">
              <div class="col-md-4" *ngIf="myrole=='14' && loginUserId != '309'">
                <div class="card">
                  <div class="table-responsive">
                      <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                          <thead>
                            <tr class="text-center">
                                <th colspan="3" class="text-center">Corporate Leads</th>
                            </tr>
                            <tr class="text-center">
                                <th style="width: 3%;">#</th>
                                <th>Status</th>
                                <th>Total Lead</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr class="text-center" *ngFor="let clead of corporate_status_wise_count_arr let index = index;" >
                                  <td style="width: 3%;">{{index+1}}</td>
                                  <td>{{clead.status_name}}</td>
                                  <td>{{clead.total_leads}}</td>
                              </tr>
                              <tr *ngIf="cor_ret_status_loading">
                                  <td colspan="3" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                </div>
              </div>

              <div class="col-md-4" *ngIf="myrole=='14' && loginUserId != '309'">
                <div class="card">
                  <div class="table-responsive">
                      <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                          <thead>
                            <tr class="text-center">
                                <th colspan="3" class="text-center">Retail Leads</th>
                            </tr>
                            <tr class="text-center">
                                <th style="width: 3%;">#</th>
                                <th>Status</th>
                                <th>Total Lead</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr class="text-center" *ngFor="let rlead of retail_status_wise_count_arr let index = index;" >
                                  <td style="width: 3%;">{{index+1}}</td>
                                  <td>{{rlead.status_name}}</td>
                                  <td>{{rlead.total_leads}}</td>
                              </tr>
                              <tr *ngIf="cor_ret_status_loading">
                                  <td colspan="3" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                </div>
              </div>

              <div class="col-md-4"  *ngIf="cm_access == '1'">
                <div class="card" style="height: 370px;">
                  <div class="table-responsive">
                      <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                          <thead>
                            <tr class="text-center">
                                <th colspan="3" class="text-center">Partner Leads</th>
                            </tr>
                            <tr class="text-center">
                                <th style="width: 3%;">#</th>
                                <th>Status</th>
                                <th>Total Lead</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr class="text-center" *ngFor="let rlead of partner_status_wise_count_arr let index = index;" >
                                  <td style="width: 3%;">{{index+1}}</td>
                                  <td>{{rlead.name}}</td>
                                  <td>{{rlead.total_leads}}</td>
                              </tr>
                              <tr *ngIf="cor_ret_status_loading">
                                  <td colspan="3" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                </div>
              </div>

              <div class="col-md-12" *ngIf="cm_access == '1'">
                <div class="card" style="height: 370px;">
                  <div class="table-responsive">
                      <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                          <thead>
                            <tr class="text-center">
                                <th colspan="9" class="text-center">Partner's Leads</th>
                            </tr>
                            <tr class="text-center">
                                <th style="width: 3%;">#</th>
                                <th>Status</th>
                                <th>True Cover</th>
                                <th>Medibuddy</th>
                                <th>Affinity Referral</th>
                                <th>Secure Now</th>
                                <th>Healthy Sure</th>
                                <th>Truventiv</th>
                                <th>Watchful Eye</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr class="text-center" *ngFor="let rlead of corporate_lead_partner_status_wise let index = index;" >
                                  <td style="width: 3%;">{{index+1}}</td>
                                  <td>{{rlead.name}}</td>
                                  <td>{{rlead.total_truecover}}</td>
                                  <td>{{rlead.total_medibuddy}}</td>
                                  <td>{{rlead.total_affinity_referral}}</td>
                                  <td>{{rlead.total_secure_now}}</td>
                                  <td>{{rlead.total_healthy_sure}}</td>
                                  <td>{{rlead.total_truventiv}}</td>
                                  <td>{{rlead.total_watchfuleye}}</td>
                              </tr>
                              <tr *ngIf="cor_partner_status_loading">
                                <td colspan="9" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                              </tr>
                              <tr class="text-center" >
                                <td style="width: 3%;"></td>
                                <td><b>Total</b></td>
                                <td><b>{{total_truecover}}</b></td>
                                <td><b>{{total_medibuddy}}</b></td>
                                <td><b>{{total_affinity_referral}}</b></td>
                                <td><b>{{total_secure_now}}</b></td>
                                <td><b>{{total_healthy_sure}}</b></td>
                                <td><b>{{total_truventiv}}</b></td>
                                <td><b>{{total_watchfuleye}}</b></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                </div>
              </div>


            </div>

            
            <!-------For Corporate BDs ------------>

            <!----------For Glamyo Partner Dashboard------------->
            <div class="col-md-6" *ngIf="myrole=='16'">
              <div class="card" style="height: 370px;">
                <div class="table-responsive">
                    <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                        <thead>
                          <tr class="text-center">
                              <th colspan="5" class="text-center">Leads</th>
                          </tr>
                          <tr class="text-center">
                              <th style="width: 3%;">#</th>
                              <th>Status</th>
                              <th>Total Leads</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let rlead of corporate_lead_partner_status_wise let index = index;" >
                                <td style="width: 3%;">{{index+1}}</td>
                                <td>{{rlead.name}}</td>
                                <td>{{rlead.total_lsouce}}</td>
                            </tr>
                            <tr *ngIf="cor_partner_status_loading">
                              <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                            </tr>
                            <tr class="text-center" >
                              <td style="width: 3%;"></td>
                              <td><b>Total</b></td>
                              <td><b>{{total_lead_source_data}}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
              </div>
            </div>
             <!----------For Glamyo Partner Dashboard------------->


            <div class="row row-cards mt-2" *ngIf="myrole=='1' || myrole=='18'">
                <div class="card">
                  <div class="table-responsive">
                      <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                          <thead>
                              <tr class="text-center">
                                  <th style="width: 3%;">#</th>
                                  <th>Circle</th>
                                  <th>Today OPD</th>
                                  <th>Today IPD</th>
                                  <th>Today Discharge</th>
                                  <th>Tomorrow Admission</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr class="text-center" *ngFor="let tdata of TodayCirclewiseIpdCounts let index = index;" >
                                  <td style="width: 3%;">{{index+1}}</td>
                                  <td>{{tdata.name}}</td>
                                  <td>{{tdata.todayOpds}}</td>
                                  <td>{{tdata.today_ipds}}</td>
                                  <td>{{tdata.todayDischange}}</td>
                                  <td>{{tdata.tomorrow_adminsion}}</td>
                              </tr>
                              <tr *ngIf="loading">
                                  <td colspan="8" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                              </tr>
                              <tr class="text-center">
                                <td style="width: 3%;"></td>
                                <td><b>Total</b></td>
                                <td><b>{{today_opds}}</b></td>
                                <td><b>{{today_ipds}}</b></td>
                                <td><b>{{todaytotalDischange}}</b></td>
                                <td><b>{{total_tomorrow_adminsion}}</b></td>
                            </tr>
                             
                          </tbody>
                      </table>
                  </div>
                </div>
            </div> 

            <div class="row row-cards mt-2" *ngIf="myrole=='1' || myrole=='8' || myrole=='18'">
              <div class="card">
                <div class="table-responsive">
                    <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                        <thead>
                            <tr class="text-center">
                                <th style="width: 3%;">#</th>
                                <th>Category</th>
                                <th>Today OPD</th>
                                <th>Today IPD</th>
                                <th>Today Discharge</th>
                                <th>Tomorrow Admission</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let tdata of TodayCategorywiseIpdCounts let index = index;" >
                                <td style="width: 3%;">{{index+1}}</td>
                                <td>{{tdata.name}}</td>
                                <td>{{tdata.todayOpds}}</td>
                                <td>{{tdata.today_ipds}}</td>
                                <td>{{tdata.todayDischange}}</td>
                                <td>{{tdata.tomorrow_adminsion}}</td>
                            </tr>
                            <tr *ngIf="loading">
                                <td colspan="8" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                            </tr>
                            <tr class="text-center">
                              <td style="width: 3%;"></td>
                              <td><b>Total</b></td>
                              <td><b>{{today_category_opds}}</b></td>
                              <td><b>{{today_category_ipds}}</b></td>
                              <td><b>{{today_category_totalDischange}}</b></td>
                              <td><b>{{total_category_tomorrow_adminsion}}</b></td>
                          </tr>
                           
                        </tbody>
                    </table>
                </div>
              </div>
          </div>

          <!-- Deepak -->
          <div class="row row-cards mt-2" *ngIf="myrole=='1' || myrole=='8'  || myrole=='18'">
            <div class="card">
              <div class="table-responsive">
                  <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                      <thead>
                          <tr class="text-center">
                              <th style="width: 3%;">#</th>
                              <th>Circle</th>
                              <th>Procto</th>
                              <th>Urology Circumcision</th>
                              <th>Laproscopy</th>
                              <th>Ortho</th>
                              <th>Vascular</th>
                              <th>Kidney Stone</th>
                              <th>Cosmetic</th>
                              <th>ENT</th>
                              <th>Ophthalmology</th>
                              <th>Dental</th>
                              <th>General Medicine</th>
                              <th>Urology Kidney</th>
                              <th>Total</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr class="text-center" *ngFor="let tdata of TodayCircleCategorywiseIpdCounts let index = index;" >
                              <td style="width: 3%;">{{index+1}}</td>
                              <td>{{tdata.circle}}</td>
                              <td>{{tdata.practo}}</td>
                              <td>{{tdata.urology_circumcision}}</td>
                              <td>{{tdata.laproscopy}}</td>
                              <td>{{tdata.ortho}}</td>
                              <td>{{tdata.vascular}}</td>
                              <td>{{tdata.kidney_stone}}</td>
                              <td>{{tdata.cosmetic}}</td>
                              <td>{{tdata.ent}}</td>
                              <td>{{tdata.opthomology}}</td>
                              <td>{{tdata.dental}}</td>
                              <td>{{tdata.general_medicine}}</td>
                              <td>{{tdata.urology_kideny}}</td>
                              <td>{{tdata.grand_total}}</td>
                          </tr>
                          <tr *ngIf="loading">
                              <td colspan="8" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                          </tr>
                          <tr class="text-center">
                            <td style="width: 3%;"></td>
                            <td><b>Total</b></td>
                            <td><b>{{today_practo_ipds}}</b></td>
                            <td><b>{{today_urology_circumcision_ipds}}</b></td>
                            <td><b>{{today_laproscopy_ipds}}</b></td>
                            <td><b>{{today_ortho_ipds}}</b></td>
                            <td><b>{{today_vascular_ipds}}</b></td>
                            <td><b>{{today_kidney_stone_ipds}}</b></td>
                            <td><b>{{today_cosmetic__ipds}}</b></td>
                            <td><b>{{today_ent_ipds}}</b></td>
                            <td><b>{{today_opthomology_ipds}}</b></td>
                            <td><b>{{today_dental_ipds}}</b></td>
                            <td><b>{{today_general_medicine_ipds}}</b></td>
                            <td><b>{{today_urology_kideny_ipds}}</b></td>
                            <td><b>{{today_total_ipds}}</b></td>
                        </tr>
                         
                      </tbody>
                  </table>
              </div>
            </div>
        </div> 
          <!-- end -->

          <!-- For all ipd Revenue-->
          <div class="row row-cards mt-2" *ngIf="myrole=='1' && (loginUserId=='89'|| loginUserId=='102')">
            <div class="col-sm-12">
              <h2>Revenue</h2>
            </div>
            <div class="row">
              <div class="col-sm-12 text-right" *ngIf="filter=='overall'">
              <mat-form-field appearance="fill">
                  <mat-label>Enter a date range</mat-label>
                  <mat-date-range-input [rangePicker]="picker">
                      <input matStartDate #dateRangeStart7 placeholder="Start date">
                      <input matEndDate #dateRangeEnd7 placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart7, dateRangeEnd7,7)">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
              <mat-icon (click)="clearDate(7)">clear</mat-icon>
              </div>
            </div>
            <div class="card">
              <div class="table-responsive">
                  <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                      <thead>
                          <tr class="text-center">
                              <th style="width: 3%;">#</th>
                              <th>Category</th>
                              <th>Total Revenue</th>
                              <th>Glamyo Shares</th>
                              <th>Hospital Shares</th>
                              <th>Doctor Shares</th>
                              <th>Actual Revenue</th>
                          </tr>
                      </thead>
                      <tbody *ngIf="!revenueloading">
                          <tr class="text-center" *ngFor="let totalRevenue of OverAllCategoryWiseRevenue let index = index;" >
                              <td style="width: 3%;">{{index+1}}</td>
                              <td>{{totalRevenue.name}}</td>
                              <td>
                                <span *ngIf="totalRevenue.billed_amt;else other_content1">
                                  {{totalRevenue.billed_amt  | number : '1.2-2' }}
                                </span>
                                <ng-template #other_content1>0</ng-template>
                              </td>
                              <td>
                                <span *ngIf="totalRevenue.glamyo_share;else other_content2">
                                  {{totalRevenue.glamyo_share  | number : '1.2-2' }}
                                </span>
                                <ng-template #other_content2>0</ng-template>
                              </td>
                              <td>
                                <span *ngIf="totalRevenue.hospital_share;else other_content3">
                                  {{totalRevenue.hospital_share  | number : '1.2-2' }}
                                </span>
                                <ng-template #other_content3>0</ng-template>
                              </td>
                              <td>
                                <span *ngIf="totalRevenue.doctor_share;else other_content4">
                                  {{totalRevenue.doctor_share  | number : '1.2-2' }}
                                </span>
                                <ng-template #other_content4>0</ng-template>
                              </td>
                              <td>
                                <span *ngIf="totalRevenue.actual_revenue;else other_content5">
                                  {{totalRevenue.actual_revenue  | number : '1.2-2' }}
                                </span>
                                <ng-template #other_content5>0</ng-template>
                              </td>
                              
                          </tr>
                          
                          <tr class="text-center">
                            <td style="width: 3%;"></td>
                            <td><b>Total</b></td>
                            <td><b>{{totalRevenueBilled_amt | number : '1.2-2'}}</b></td>
                            <td><b>{{totalRevenueGlamyo_share | number : '1.2-2'}}</b></td>
                            <td><b>{{totalRevenueHospital_share | number : '1.2-2'}}</b></td>
                            <td><b>{{totalRevenueDoctor_share | number : '1.2-2'}}</b></td>
                            <td><b>{{totalRevenueActual_revenue | number : '1.2-2'}}</b></td>
                          </tr>
                         
                      </tbody>
                      <tr *ngIf="revenueloading">
                        <td colspan="8" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                      </tr>
                  </table>
              </div>
            </div>
          </div>
          <!-- end -->

            <div class="row row-cards mt-2" *ngIf="myrole=='3' || myrole=='1' || myrole=='6' || myrole=='4' || myrole=='7' || myrole=='8' || myrole=='18'" style="display: none;">
              <div class="col-sm-12">
                <h2>User Wise Performance</h2>
              </div>

                <div class="col-md-4 col-lg-4 float-left pr-0 pl-0">
                   <div class="row ">
                     <div class="col-sm-8 text-right" *ngIf="filter=='overall'">
                     <mat-form-field appearance="fill">
                         <mat-label>Enter a date range</mat-label>
                         <mat-date-range-input [rangePicker]="picker">
                             <input matStartDate #dateRangeStart placeholder="Start date">
                             <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd,1)">
                         </mat-date-range-input>
                         <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                         <mat-date-range-picker #picker></mat-date-range-picker>
                     </mat-form-field>
                     <mat-icon (click)="clearDate(1)">clear</mat-icon>
                     </div>
                     <div class="col-sm-4">
                      <button type="button" *ngIf="myrole=='1' || (myrole=='4')" class="btn btn-success ml-2" [disabled]="loading" (click)="exportAppointmentReport()"><i class="fa fa-file-excel"></i> Export</button>
                     </div>
                 </div>
                </div>
                <div class="col-md-8 col-lg-8 pr-0 pl-0">
                     <div class="row">
                         <div class="col-sm-3 text-right">
                             <p class="m-10" *ngIf="myrole=='1'">
                               <label class="custom-control custom-checkbox">
                               <input type="checkbox" class="custom-control-input" (change)="getDashboardUserOpdIpdCount()" [(ngModel)]="is_cm_access" />
                               <span class="custom-control-label">Show CM/TL Users</span>
                               </label>
                             </p>
                         </div>
                         <div class="col-sm-3 text-right">
                          <p class="m-10" *ngIf="myrole=='1' || myrole=='7'">
                            <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" (change)="getDashboardUserOpdIpdCount()" [(ngModel)]="inactiveUser" />
                            <span class="custom-control-label">Show In-Active Users</span>
                            </label>
                          </p>
                        </div>
                         <div class="col-sm-3">
                           <mat-select placeholder="Select Circle"  [(ngModel)]="circle" (selectionChange)="getDashboardUserOpdIpdCount()">
                             <mat-option >All</mat-option>
                             <mat-option value="{{cir.id}}" *ngFor="let cir of circleList">{{cir.name}}</mat-option>
                           </mat-select>
                       </div>
                         <div class="col-sm-3">
                             <mat-select  [(ngModel)]="filter" (selectionChange)="getDashboardUserOpdIpdCount()">
                                 <mat-option value="overall">Overall</mat-option>
                                 <mat-option value="prevmonth">Previous Month</mat-option>
                                 <mat-option value="month">This Month</mat-option>
                             </mat-select>
                         </div>
                     </div>
                     <div class="row">
                      <div class="col-sm-3 text-right">
                        <p class="m-10">
                          <label class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" (change)="getDashboardUserOpdIpdCount()" [(ngModel)]="hasOpdIpd" />
                          <span class="custom-control-label">Users has OPD & IPD</span>
                          </label>
                        </p>
                      </div>
                     </div>
                </div>
        </div>
        <div class="row row-cards" *ngIf="myrole=='3' || myrole=='1'  || myrole=='4' || myrole=='7' || myrole=='6' || myrole=='8' || myrole=='18'" style="display: none;">
          <div class="col-sm-12 col-lg-12 pr-0 pl-0 mt-2 float-left">
            <div class="card">
              <div class="table-responsive">
                <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                  <thead>
                    <tr>
                      <th class="text-center w-1"><i class="icon-people"></i></th>
                      <th>Users</th>
                      <th>Leads</th>
                      <!-- <th>TAT (In hour)</th> -->
                      <th>OPD</th>
                      <th class="text-center">Surgery Suggested</th>
                      <th>IPD</th>
                      <th>Elective</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="box overall" *ngFor="let opdIpdList of usersOdpIpdList">
                      <td class="text-center">
                        <div class="avatar d-block avatar-md" style="background-image: url('assets/images/defalutpic.png')">
                        <!-- <span class="avatar-status bg-green"></span> -->
                        </div>
                      </td>
                      <td>
                        <div>{{opdIpdList.name}} <span *ngIf="opdIpdList.status==1" class="badge badge-success">Active</span><span *ngIf="opdIpdList.status==0" class="badge badge-danger">In-Active</span></div>
                        <div class="small text-muted">
                          {{opdIpdList.email}}
                        </div>
                      </td>
                      <td><span class="text-success">{{opdIpdList.leadCount}}</span></td>

                      <!-- <td><span *ngIf="userswiseTatList[opdIpdList.id]">{{userswiseTatList[opdIpdList.id].tat/userswiseTatList[opdIpdList.id].lead_count  | number : '1.2-2'}}</span></td> -->
                      <td>
                        <div class="clearfix">
                          <div class="float-left">
                            <strong *ngIf="opdIpdList.treatment_catergory_access=='4'">
                              {{opdIpdList.scanBooked}}
                            </strong>
                            <strong *ngIf="opdIpdList.treatment_catergory_access!='4'">
                              {{opdIpdList.activeOpdcount + opdIpdList.completedOpdcount}} <span *ngIf="opdIpdList.activeOpdcount>0">({{opdIpdList.activeOpdcount}} Active)</span> </strong>
                          </div>
                          <div class="float-right">
                            <small class="text-muted">Overall</small>
                          </div>
                        </div>
                         <div class="progress">
                            <div class="progress-bar" style="background: #5eba00;" role="progressbar" aria-valuenow="60" aria-valuemin="0"
                                aria-valuemax="opdIpdList.activeOpdcount + opdIpdList.completedOpdcount" [style.width.%]="getPercentage(25,opdIpdList.activeOpdcount+opdIpdList.completedOpdcount)">
                            </div>

                          </div>
                      </td>
                      <td class="text-center"><strong>{{opdIpdList.SurgerySuggestedCount}}</strong></td>
                      <td>
                        <div class="clearfix">
                          <div class="float-left">
                            <strong *ngIf="opdIpdList.treatment_catergory_access=='4'">
                              {{opdIpdList.scanDone}}
                            </strong>
                            <strong *ngIf="opdIpdList.treatment_catergory_access!='4'">
                              {{opdIpdList.activeIpdcount + opdIpdList.completedIpdcount}} <span *ngIf="opdIpdList.activeIpdcount>0">({{opdIpdList.activeIpdcount}} Active)</span></strong>
                          </div>
                          <div class="float-right">
                            <small class="text-muted">Overall</small>
                          </div>
                        </div>
                          <div class="progress">
                            <div class="progress-bar" style="background: #5eba00;" role="progressbar" aria-valuenow="60" aria-valuemin="0"
                                [aria-valuemax]="opdIpdList.activeIpdcount + opdIpdList.completedIpdcount" [style.width.%]="getPercentage(20,opdIpdList.activeIpdcount+opdIpdList.completedIpdcount)">
                            </div>

                          </div>

                      </td>

                      <td style="border-right: 1px solid #ccc;">
                        <div class="clearfix">
                          <div class="float-left">
                            <strong *ngIf="opdIpdList.treatment_catergory_access=='4'">
                              0
                            </strong>
                            <strong *ngIf="opdIpdList.treatment_catergory_access!='4'">
                              {{opdIpdList.completedElectiveIpds}} <span *ngIf="opdIpdList.activeIpdcount>0">({{opdIpdList.activeElectiveIpds}} Active)</span></strong>
                          </div>
                          <div class="float-right">
                            <small class="text-muted">Overall</small>
                          </div>
                        </div>
                          <div class="progress">
                            <div class="progress-bar" style="background: #5eba00;" role="progressbar" aria-valuenow="60" aria-valuemin="0"
                                [aria-valuemax]="opdIpdList.activeElectiveIpds" [style.width.%]="getPercentage(20,opdIpdList.activeElectiveIpds)">
                            </div>

                          </div>

                      </td>

                    </tr>
                   <tr class="box overall" *ngIf="loadingOPDIPD">
                      <td colspan="6" class="text-center"><i class="fas fa-spin fa-spinner fa-2x"></i></td>
                  </tr>


                  <tr class="box overall" *ngIf="!loadingOPDIPD">
                      <th></th>
                      <th>Total</th>
                      <td><span class="text-success">{{totalAppointmentCount.total_leads}}</span></td>
                      <td></td>
                      <td>
                        <span class="text-success bold">
                          {{totalAppointmentCount.activeOpd+totalAppointmentCount.completedOpd+ totalAppointmentCount.totalscanBooked}} </span> OPDs total
                        <span class="text-info" *ngIf="totalAppointmentCount.activeOpd>0">({{totalAppointmentCount.activeOpd}} Active)</span>
                      </td>
                      <td class="text-center"><span class=" text-success bold">{{totalAppointmentCount.totalCountsurgerysuggested}}</span> total</td>
                      <td>
                        <span class="text-success bold">
                        {{totalAppointmentCount.activeIpd+totalAppointmentCount.completedIpd+totalAppointmentCount.total_scanDone}} </span> IPDs total
                        <span class="text-info" *ngIf="totalAppointmentCount.activeIpd>0">({{totalAppointmentCount.activeIpd}} Active)</span>
                      </td>

                      <td>
                        <span class="text-success bold">
                        {{totalAppointmentCount.activeElectiveIpd+totalAppointmentCount.completedElectiveIpd}} </span> IPDs total
                        <span class="text-info" *ngIf="totalAppointmentCount.activeElectiveIpd>0">({{totalAppointmentCount.activeElectiveIpd}} Active)</span>
                      </td>

                  </tr>
                    </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-cards mt-2" *ngIf="myrole=='3' || myrole=='1'  || myrole=='4' || myrole=='7'" style="display: none;">
          <div class="col-sm-12">
            <h2>Doctors Wise Performance</h2>
          </div>

            <div class="col-md-6 col-lg-6 float-left pr-0 pl-0">
               <div class="row ">
                 <div class="col-sm-6 text-right" *ngIf="filter=='overall'">
                 <mat-form-field appearance="fill">
                     <mat-label>Enter a date range</mat-label>
                     <mat-date-range-input [rangePicker]="picker">
                         <input matStartDate #dateRangeStart2 placeholder="Start date">
                         <input matEndDate #dateRangeEnd2 placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart2, dateRangeEnd2,2)">
                     </mat-date-range-input>
                     <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                     <mat-date-range-picker #picker></mat-date-range-picker>
                 </mat-form-field>
                 <mat-icon (click)="clearDate(2)">clear</mat-icon>
                 </div>
             </div>
            </div>
            <div class="col-md-6 col-lg-6 pr-0 pl-0" *ngIf="myrole!='6'">
                 <div class="row">
                     <div class="col-sm-5 text-right">
                         <p class="m-10">
                           <label class="custom-control custom-checkbox">
                           <input type="checkbox" class="custom-control-input" (change)="getDashboardDoctorsOpdIpdCount()" [(ngModel)]="inactiveDoctor" />
                           <span class="custom-control-label">Show In-Active Doctors</span>
                           </label>
                         </p>
                     </div>
                     <div class="col-sm-4">
                       <mat-select placeholder="Select Circle"  [(ngModel)]="doctorcircle" (selectionChange)="getDashboardDoctorsOpdIpdCount()">
                         <mat-option >All</mat-option>
                         <mat-option value="{{cir.id}}" *ngFor="let cir of circleList">{{cir.name}}</mat-option>
                       </mat-select>
                   </div>
                     <div class="col-sm-3">
                         <mat-select  [(ngModel)]="doctorfilter" (selectionChange)="getDashboardDoctorsOpdIpdCount()">
                             <mat-option value="overall">Overall</mat-option>
                             <mat-option value="prevmonth">Previous Month</mat-option>
                             <mat-option value="month">This Month</mat-option>
                         </mat-select>
                     </div>
                 </div>
            </div>
    </div>
    <div class="row row-cards" *ngIf="myrole=='3' || myrole=='1'  || myrole=='4' || myrole=='7'" style="display: none;">
      <div class="col-sm-12 col-lg-12 pr-0 pl-0 mt-2 float-left">
        <div class="card">
          <div class="table-responsive doctorTable">
            <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
              <thead>
                <tr>
                  <th class="text-center w-1"><i class="icon-people"></i></th>
                  <th>Doctor Name</th>
                  <th>OPD</th>
                  <th class="text-center">Surgery Suggested</th>
                  <th>IPD</th>
                </tr>
              </thead>
              <tbody>
                <tr class="box overall" *ngFor="let opdIpdList of DoctorsOdpIpdList">
                  <td class="text-center">
                    <div class="avatar d-block avatar-md" style="background-image: url('assets/images/defalutpic.png')">
                    <!-- <span class="avatar-status bg-green"></span> -->
                    </div>
                  </td>
                  <td>
                    <div>{{opdIpdList.name}} <span *ngIf="opdIpdList.status==1" class="badge badge-success">Active</span><span *ngIf="opdIpdList.status==0" class="badge badge-danger">In-Active</span></div>

                  </td>
                  <td>
                    <div class="clearfix">
                      <div class="float-left">
                        <strong>
                          {{opdIpdList.activeOpdcount + opdIpdList.completedOpdcount}} <span *ngIf="opdIpdList.activeOpdcount>0">({{opdIpdList.activeOpdcount}} Active)</span> </strong>
                      </div>
                      <div class="float-right">
                        <small class="text-muted">Overall</small>
                      </div>
                    </div>
                     <div class="progress">
                        <div class="progress-bar" style="background: #5eba00;" role="progressbar" aria-valuenow="60" aria-valuemin="0"
                            aria-valuemax="opdIpdList.activeOpdcount + opdIpdList.completedOpdcount" [style.width.%]="getPercentage(25,opdIpdList.activeOpdcount+opdIpdList.completedOpdcount)">
                        </div>

                      </div>
                  </td>
                  <td class="text-center"><strong>{{opdIpdList.SurgerySuggestedCount}}</strong></td>
                  <td>
                    <div class="clearfix">
                      <div class="float-left">
                        <strong>
                          {{opdIpdList.AllIpds}} <span *ngIf="opdIpdList.activeIpdcount>0">({{opdIpdList.activeIpdcount}} Active)</span></strong>
                      </div>
                      <div class="float-right">
                        <small class="text-muted">Overall</small>
                      </div>
                    </div>
                      <div class="progress">
                        <div class="progress-bar" style="background: #5eba00;" role="progressbar" aria-valuenow="60" aria-valuemin="0"
                            [aria-valuemax]="opdIpdList.activeIpdcount + opdIpdList.completedIpdcount" [style.width.%]="getPercentage(20,opdIpdList.activeIpdcount+opdIpdList.completedIpdcount)">
                        </div>

                      </div>

                  </td>

                </tr>
               <tr class="box overall" *ngIf="loadingdoctorsOPDIPD">
                  <td colspan="6" class="text-center"><i class="fas fa-spin fa-spinner fa-2x"></i></td>
              </tr>


              <tr class="box overall" *ngIf="!loadingdoctorsOPDIPD">
                  <th></th>
                  <th>Total</th>
                  <td>
                    <span class="text-success bold">
                      {{DoctorstotalAppointmentCount.activeOpd+DoctorstotalAppointmentCount.completedOpd}} </span> OPDs total
                    <span class="text-info" *ngIf="DoctorstotalAppointmentCount.activeOpd>0">({{DoctorstotalAppointmentCount.activeOpd}} Active)</span>
                  </td>
                  <td></td>
                  <td>
                    <span class="text-success bold">
                    {{DoctorstotalAppointmentCount.activeIpd+DoctorstotalAppointmentCount.completedIpd}} </span> IPDs total
                    <span class="text-info" *ngIf="DoctorstotalAppointmentCount.activeIpd>0">({{DoctorstotalAppointmentCount.activeIpd}} Active)</span>
                  </td>


              </tr>
                </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row row-cards" *ngIf="myrole=='1'">
      <div class="col-sm-12">
        <h2>Insurance TAT</h2>
      </div>
      <div class="col-md-3 col-lg-3 float-left pr-0 pl-0">
        <div *ngIf="insFilter=='overall'">
          <mat-form-field appearance="fill">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                  <input matStartDate #dateRangeStart4 placeholder="Start date">
                  <input matEndDate #dateRangeEnd4 placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart4, dateRangeEnd4,4)">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
          <mat-icon class="insurance_tat_clear" (click)="clearDate(4)">clear</mat-icon>
        </div>
     </div>
     <div class="col-sm-3 float-right">
      <mat-select  [(ngModel)]="insFilter" (selectionChange)="getInsuranceCardTat()">
          <mat-option value="overall">Overall</mat-option>
          <mat-option value="prevmonth">Previous Month</mat-option>
          <mat-option value="month">This Month</mat-option>
      </mat-select>
      </div>
      <div class="col-sm-12 col-lg-12 pr-0 pl-0 mt-2 float-left">
        <div class="card">
          <div class="table-responsive">
            <table class="table table-hover table-bordered table-vcenter text-nowrap card-table">
              <thead>
                <tr>
                  <th class="text-center w-1"><i class="icon-people"></i></th>
                  <th class="thstyle">User</th>
                  <th class="thstyle">TAT(In hour)</th>
                  <th class="thstyle">Total Leads</th>
                  <th class="thstyle">Pending</th>
                  <th class="thstyle">Approved</th>
                  <th class="thstyle" colspan="1">Pre Auth Pending</th>
                  <th class="thstyle" colspan="2">Pre Approval</th>
                  <th class="thstyle" colspan="2">Final Approval</th>
                  
                </tr>
              </thead>
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>

                  <th>&nbsp;</th>
                  

                  <th>Pending</th>
                  <th>Approved</th>

                  <th>Pending</th>
                  <th>Approved</th>

                  
                </tr>
              </thead>
              <tbody class="text-center">
                <tr class="box overall" *ngFor="let cardTat of insuranceCardTat;">
                  <td class="text-center">
                    <div class="avatar d-block avatar-md" style="background-image: url('assets/images/defalutpic.png')">
                    </div>
                  </td>
                  <td>
                    <div>{{cardTat.userName}}</div>
                  </td>
                  <td><span>{{cardTat.tat| number : '1.2-2'}} </span></td>
                  <td><span>{{cardTat.user_ins_count}} </span></td>
                  <td>
                    <span *ngIf="cardTat.status_report.pending">{{cardTat.status_report.pending}}</span>
                    <span *ngIf="!cardTat.status_report.pending">0</span>
                  </td>
                  <td>
                    <span *ngIf="cardTat.status_report.approved">{{cardTat.status_report.approved}}</span>
                    <span *ngIf="!cardTat.status_report.approved">0</span>
                  </td>
                  <td>
                    <span *ngIf="cardTat.status_report.pre_auth_pending">{{cardTat.status_report.pre_auth_pending}}</span>
                    <span *ngIf="!cardTat.status_report.pre_auth_pending">0</span>
                  </td>
                  
                  <td>
                    <span *ngIf="cardTat.status_report.pre_approval_pending">{{cardTat.status_report.pre_approval_pending}}</span>
                    <span *ngIf="!cardTat.status_report.pre_approval_pending">0</span>
                  </td>
                  <td>
                    <span *ngIf="cardTat.status_report.pre_approval_approved">{{cardTat.status_report.pre_approval_approved}}</span>
                    <span *ngIf="!cardTat.status_report.pre_approval_approved">0</span>
                  </td>

                  <td>
                    <span *ngIf="cardTat.status_report.final_approval_pending">{{cardTat.status_report.final_approval_pending}}</span>
                    <span *ngIf="!cardTat.status_report.final_approval_pending">0</span>
                  </td>
                  <td>
                    <span *ngIf="cardTat.status_report.final_approval_approved">{{cardTat.status_report.final_approval_approved}}</span>
                    <span *ngIf="!cardTat.status_report.final_approval_approved">0</span>
                  </td>

                  
                </tr>
               <tr class="box overall" *ngIf="loadingdoctorsOPDIPD">
                  <td colspan="11" class="text-center"><i class="fas fa-spin fa-spinner fa-2x"></i></td>
              </tr>
              <tr *ngIf="insuranceCardTat && !insuranceCardTat.length">
                <td colspan="11" ><i class="far fa-frown"></i> No Data Found</td>
              </tr>
                </tbody>
            </table>
          </div>
        </div>
      </div>
    </div> -->

    <div class="row row-cards" *ngIf="myrole=='1'">
      <div class="col-sm-12">
        <h2>Insurance TAT</h2>
      </div>
      <div class="col-md-3" *ngIf="insFilterRev=='overall'">
        <div>
          <mat-form-field appearance="fill">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                  <input matStartDate #dateRangeStart5 placeholder="Start date">
                  <input matEndDate #dateRangeEnd5 placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart5, dateRangeEnd5,5)">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
          <mat-icon class="insurance_tat_clear" (click)="clearDate(5)">clear</mat-icon>
        </div>
    </div>
    <div class="col-md-3">
      <mat-select  [(ngModel)]="insFilterRev" (selectionChange)="getInsuranceReportofPreAuthApprovalFinal()">
          <mat-option value="today">Today</mat-option>
          <mat-option value="overall">Overall</mat-option>
          <mat-option value="prevmonth">Previous Month</mat-option>
          <mat-option value="month">This Month</mat-option>
      </mat-select>
      </div>
      
    <div class="col-12 col-sm-12 col-lg-12 mt-5">
      <div class="card">
        <div class="table-responsive">
            <table class="table table-hover table-bordered table-vcenter text-nowrap card-table">
                <thead>
                  <!-- <tr class="text-center">
                      <th colspan="11" class="text-center">Today's Data</th>
                  </tr> -->
                  <tr class="text-center">
                    <th class="thstyle"></th>
                    <th class="thstyle"></th>
                    <th class="thstyle"></th>
                    <th class="thstyle"></th>
                    <th class="thstyle"></th>
                    <th class="thstyle"></th>
                    <th class="thstyle" colspan = "2">Pre Approval</th>
                    <th class="thstyle" colspan = "2">Final Approval</th>
                  </tr>
                  <tr class="text-center">
                    <th class="text-center w-1"><i class="icon-people"></i></th>
                    <th class="thstyle">User</th>
                    <th class="thstyle">Pending</th>
                    <th class="thstyle">Approved</th>
                    <th class="thstyle">Rejected</th>
                    <th class="thstyle">Pre Auth Pending</th>
                    <th class="thstyle">Pending</th>
                    <!-- <th class="thstyle">Pre Approval Query</th> -->
                    <th class="thstyle">Approved</th>
                    <th class="thstyle">Pending</th>
                    <!-- <th class="thstyle">Final Approval Query</th> -->
                    <th class="thstyle">Approved</th>
                  </tr>
                </thead>
                <tbody>
                    <tr  *ngFor="let hreport of insuranceHistoryReport" class="text-center" >
                        <td>
                          <div class="avatar d-block avatar-md" style="background-image: url('assets/images/defalutpic.png')">
                          </div>
                        </td>
                        <td>{{hreport.name}}</td>
                        <td>{{hreport.total_data[0]['pending']}}</td>
                        <td>{{hreport.total_data[0]['approved']}}</td>
                        <td>{{hreport.total_data[0]['rejected']}}</td>
                        <td>{{hreport.total_data[0]['pre_auth_pending_total']}}</td>
                        <!--  <td>{{insuranceHistoryReport.pre_auth_query_total}}</td>
                        <td>{{insuranceHistoryReport.pre_auth_approved_total}}</td> -->
                        <td>{{hreport.total_data[0]['pre_approval_pending_total']}}</td>
                        <!-- <td>{{hreport.total_data[0]['pre_approval_query_total']}}</td> -->
                        <td>{{hreport.total_data[0]['pre_approval_approved_total']}}</td>
                        <td>{{hreport.total_data[0]['final_approval_pending_total']}}</td>
                        <!-- <td>{{hreport.total_data[0]['final_approval_query_total']}}</td> -->
                        <td>{{hreport.total_data[0]['final_approval_approved_total']}}</td> 
                    </tr>
                    <tr class="text-center" >
                      <td></td>
                      <td class="thstyle">Total</td>
                       <td class="thstyle">{{insuranceHistoryReportTotal['total_pending']}}</td>
                      <td class="thstyle">{{insuranceHistoryReportTotal['total_approved']}}</td>
                      <td class="thstyle">{{insuranceHistoryReportTotal['total_rejected']}}</td>
                      <td class="thstyle">{{insuranceHistoryReportTotal['total_preauth_pending']}}</td>
                      <td class="thstyle">{{insuranceHistoryReportTotal['total_preapproval_pending']}}</td>
                      <td class="thstyle">{{insuranceHistoryReportTotal['total_preapproval_approved']}}</td>
                      <td class="thstyle">{{insuranceHistoryReportTotal['total_finalapproval_pending']}}</td>
                      <td class="thstyle">{{insuranceHistoryReportTotal['total_finalapproval_approved']}}</td> 
                    </tr>
                    <tr *ngIf="loadinghistyoryTat">
                        <td colspan="12" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>
  </div>

    <!-- <app-insurance-tracker-list></app-insurance-tracker-list> -->

        <div class="row row-cards" *ngIf="myrole!='6' && myrole!='14' && myrole!='16'  && myrole!='19' && myrole!='20' && myrole!='21' && myrole!='23' && myrole!='24'">
          <div class="col-sm-12 col-lg-12 pr-0 pl-0 mt-2 float-left">
            <h2>Today's Admission</h2>
            <div class="card">
              <div class="table-responsive">
                <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                  <thead>
                    <tr>
                      <th>Paitent Name</th>
                      <!-- <th *ngIf="myrole!='7' && myrole!='10'">Paitent Mobile</th> -->
                      <th>Circle</th>
                      <th>Lead Owner</th>
                      <th>Treatment</th>
                      <th>Doctor</th>
                      <th>Hospital</th>
                      <th>Room</th>
                      <th>Payment Mode</th>
                      <th>Billed Amount</th>
                      <th>Surgery Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="box overall" *ngFor="let todayAdmission of todayAdmissionList">
                      <td>{{todayAdmission.patient}}</td>
                      <!-- <td *ngIf="myrole!='7' && myrole!='10'">{{todayAdmission.phone}}</td> -->
                      <td>{{todayAdmission.circle_name}}</td>
                      <td>{{todayAdmission.bd_name}}</td>
                      <td>{{todayAdmission.treatmentName}}</td>
                      <td>{{todayAdmission.doctor_name}}</td>
                      <td>{{todayAdmission.hospital_name}}</td>
                      <td>{{getRoomCategory(todayAdmission.room)}}</td>
                      <td>{{getPaymentType(todayAdmission.payment_mode)}}</td>
                      <td>{{todayAdmission.billed_amt | number : '1.2-2'}}</td>
                      <td>{{todayAdmission.surgery_date*1000|date:'d MMM, yyyy'}}</td>
                      <td>
                        <span class='p-2 badge' [ngClass]="{'badge-info':todayAdmission.status==0}" *ngIf="todayAdmission.status==0"><i class="fa fa-dot-circle"></i> Active</span>
                        <span class='p-2 badge' [ngClass]="{'badge-success':todayAdmission.status==1}" *ngIf="todayAdmission.status==1"><i class="fa fa-check"></i> Completed</span>
                        <span class='p-2 badge' [ngClass]="{'badge-danger':todayAdmission.status==3}" *ngIf="todayAdmission.status==3"><i class="fa fa-times"></i> Cancelled</span>
                      </td>
                    </tr>
                    <tr *ngIf="admissionloading">
                      <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                  </tr>
                  <tr *ngIf="admissionloaded && !todayAdmissionList.length">
                      <td colspan="20" ><i class="far fa-frown"></i> No Data Found</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-cards" *ngIf="myrole!='14' && myrole!='16' && myrole!='19' && myrole!='20'  && myrole!='21' && myrole!='23' && myrole!='24'">
          <div class="col-sm-12 col-lg-12 pr-0 pl-0 mt-2 float-left">
            <h2>Today's Discharge</h2>
            <div class="card">
              <div class="table-responsive">
                <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                  <thead>
                    <tr>
                      <th>Paitent Name</th>
                      <!-- <th *ngIf="myrole!='7' && myrole!='10'">Paitent Mobile</th> -->
                      <th>Circle</th>
                      <th>Lead Owner</th>
                      <th>Treatment</th>
                      <th>Doctor</th>
                      <th>Hospital</th>
                      <th>Room</th>
                      <th>Payment Mode</th>
                      <th>Billed Amount</th>
                      <th>Surgery Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="box overall" *ngFor="let todayAdmission of todayDischargeList">
                      <td>{{todayAdmission.patient}}</td>
                      <!-- <td *ngIf="myrole!='7'  && myrole!='10'">{{todayAdmission.phone}}</td> -->
                      <td>{{todayAdmission.circle_name}}</td>
                      <td>{{todayAdmission.bd_name}}</td>
                      <td>{{todayAdmission.treatmentName}}</td>
                      <td>{{todayAdmission.doctor_name}}</td>
                      <td>{{todayAdmission.hospital_name}}</td>
                      <td>{{getRoomCategory(todayAdmission.room)}}</td>
                      <td>{{getPaymentType(todayAdmission.payment_mode)}}</td>
                      <td>{{todayAdmission.billed_amt | number : '1.2-2'}}</td>
                      <td>{{todayAdmission.surgery_date*1000|date:'d MMM, yyyy'}}</td>
                      <td>
                        <span class='p-2 badge' [ngClass]="{'badge-info':todayAdmission.status==0}" *ngIf="todayAdmission.status==0"><i class="fa fa-dot-circle"></i> Active</span>
                        <span class='p-2 badge' [ngClass]="{'badge-success':todayAdmission.status==1}" *ngIf="todayAdmission.status==1"><i class="fa fa-check"></i> Completed</span>
                        <span class='p-2 badge' [ngClass]="{'badge-danger':todayAdmission.status==3}" *ngIf="todayAdmission.status==3"><i class="fa fa-times"></i> Cancelled</span>
                      </td>
                    </tr>
                    <tr *ngIf="dischargeloading">
                      <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                  </tr>
                  <tr *ngIf="dischargeloaded && !todayDischargeList.length">
                      <td colspan="20" ><i class="far fa-frown"></i> No Data Found</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="myrole=='1' || myrole=='7'">
            <app-today-admission-today-discharge></app-today-admission-today-discharge>
        </div>

        <div *ngIf="myrole=='1' || myrole=='8'">
          <app-patient-journey-city-wise></app-patient-journey-city-wise>
        </div>

        <div class="row row-cards" *ngIf="myrole=='1' || myrole=='4' || myrole=='5' || myrole=='8' || myrole=='10'">
          <div class="col-sm-12 col-lg-12 pr-0 pl-0 mt-2 float-left">
            <h2>Tomorrow's Admission</h2>
            <div class="card">
              <div class="table-responsive">
                <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                  <thead>
                    <tr>
                      <th>Paitent Name</th>
                      <!-- <th *ngIf="myrole!='10'">Paitent Mobile</th> -->
                      <th>Circle</th>
                      <th>Lead Owner</th>
                      <th>Treatment</th>
                      <th>Doctor</th>
                      <th>Hospital</th>
                      <th>Room</th>
                      <th>Payment Mode</th>
                      <th>Billed Amount</th>
                      <th>Surgery Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="box overall" *ngFor="let tomorrowAdmission of tomorrowAdmissionList">
                      <td>{{tomorrowAdmission.patient}}</td>
                      <!-- <td *ngIf="myrole!='10'">{{tomorrowAdmission.phone}}</td> -->
                      <td>{{tomorrowAdmission.circle_name}}</td>
                      <td>{{tomorrowAdmission.bd_name}}</td>
                      <td>{{tomorrowAdmission.treatmentName}}</td>
                      <td>{{tomorrowAdmission.doctor_name}}</td>
                      <td>{{tomorrowAdmission.hospital_name}}</td>
                      <td>{{getRoomCategory(tomorrowAdmission.room)}}</td>
                      <td>{{getPaymentType(tomorrowAdmission.payment_mode)}}</td>
                      <td>{{tomorrowAdmission.billed_amt | number : '1.2-2'}}</td>
                      <td>{{tomorrowAdmission.surgery_date*1000|date:'d MMM, yyyy'}}</td>
                      <td>
                        <span class='p-2 badge' [ngClass]="{'badge-info':tomorrowAdmission.status==0}" *ngIf="tomorrowAdmission.status==0"><i class="fa fa-dot-circle"></i> Active</span>
                        <span class='p-2 badge' [ngClass]="{'badge-success':tomorrowAdmission.status==1}" *ngIf="tomorrowAdmission.status==1"><i class="fa fa-check"></i> Completed</span>
                        <span class='p-2 badge' [ngClass]="{'badge-danger':tomorrowAdmission.status==3}" *ngIf="tomorrowAdmission.status==3"><i class="fa fa-times"></i> Cancelled</span>
                      </td>
                    </tr>
                    <tr *ngIf="admissionloading">
                      <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                  </tr>
                  <tr *ngIf="admissionloaded && !tomorrowAdmissionList.length">
                      <td colspan="20" ><i class="far fa-frown"></i> No Data Found</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Today-OPD-List -->
        <div class="row row-cards" *ngIf="myrole!='6' && myrole!='14' && myrole!='16' && myrole!='19' && myrole!='20'  && myrole!='21'  && myrole!='23' && myrole!='24'">
          <div class="col-sm-12 col-lg-12 pr-0 pl-0 mt-2 float-left">
            <h2>Today's Opd</h2>
            <div class="card">
              <div class="table-responsive">
                <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                  <thead>
                    <tr>
                      <th>Paitent Name</th>
                      <!-- <th *ngIf="myrole=='1' && myrole!='10'">Paitent Mobile</th> -->
                      <th>Circle</th>
                      <th>Lead Owner</th>
                      <th>Treatment</th>
                      <th>Doctor</th>
                      <th>Hospital</th>

                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="box overall" *ngFor="let todayAdmission of todayOpdAdmissionList">
                      <td>{{todayAdmission.patient}}</td>
                      <!-- <td *ngIf="myrole!='7'  && myrole!='10'">{{todayAdmission.phone}}</td> -->
                      <td>{{todayAdmission.circle_name}}</td>
                      <td>{{todayAdmission.bd_name}}</td>
                      <td>{{todayAdmission.treatmentName}}</td>
                      <td>{{todayAdmission.doctor_name}}</td>
                      <td>{{todayAdmission.hospital_name}}</td>

                      <td>
                        <span class='p-2 badge' [ngClass]="{'badge-info':todayAdmission.status==0}" *ngIf="todayAdmission.status==0"><i class="fa fa-dot-circle"></i> Active</span>
                        <span class='p-2 badge' [ngClass]="{'badge-success':todayAdmission.status==1}" *ngIf="todayAdmission.status==1"><i class="fa fa-check"></i> Completed</span>
                        <span class='p-2 badge' [ngClass]="{'badge-danger':todayAdmission.status==3}" *ngIf="todayAdmission.status==3"><i class="fa fa-times"></i> Cancelled</span>
                      </td>
                    </tr>
                    <tr *ngIf="admissionloading">
                      <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                  </tr>
                  <tr *ngIf="!todayOpdadmissionloading && !todayOpdAdmissionList.length">
                      <td colspan="20" ><i class="far fa-frown"></i> No Data Found</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Payment Stats -->
        <div class="row row-cards" *ngIf="myrole=='1' || (myrole=='3' && cm_access == '1')">
          <div class="col-sm-12 col-lg-12 pr-0 pl-0 mt-2 float-left">
            <h2>Payment Stats Circle Wise</h2>
            <div class="row ">
              <div class="row col-sm-12">
                <div class="col-sm-6">
                  <mat-form-field appearance="fill">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate #dateRangeStart3 placeholder="Start date">
                        <input matEndDate #dateRangeEnd3 placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart3, dateRangeEnd3,3)">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                  </mat-form-field>
                  <mat-icon (click)="clearDate(3)">clear</mat-icon>
                </div>
                <div class="col-sm-4">
                  <mat-select placeholder="Select Treatment Catergory" [(ngModel)]="treatment_catergory" (selectionChange)="getPaymentsStats()">
                    <mat-option >All</mat-option>
                    <mat-option value="{{tc.id}}" *ngFor="let tc of treatCategory">{{tc.name}}</mat-option>
                  </mat-select>
                </div>
             
              </div>
            </div>
            <div class="card">
              <div class="table-responsive">
                <table class="table table-hover table-bordered table-vcenter text-nowrap card-table">
                  <thead>
                    <tr>
                      <th class="thstyle">Particulars</th>
                      <th class="thstyle" colspan="3">Ipd Count</th>
                      <th class="thstyle" colspan="3">ATS</th>
                      <th class="thstyle" colspan="7">Billing</th>
                      <th class="thstyle" colspan="12">Net IPD Revenue</th>
                    </tr>
                  </thead>
                  <thead>
                    <tr>
                      <th></th>

                      <th>Combined</th>
                      <th>Insurance</th>
                      <th>Cash/EMI</th>

                      <th>Combined</th>
                      <th>Insurance</th>
                      <th>Cash</th>

                      <th>Gross Bill</th>
                      <th>Insurance</th>
                      <th>Cash/EMI</th>
                      <th>MOU Discount</th>
                      <th>Co Pay</th>
                      <th>Consumable</th>
                      <th>Patient Paid</th>

                      <th>Settled Amount (Combined)</th>
                      <th>Glamyo Share (Combined)</th>
                      <th>Hospital Share (Combined)</th>
                      <th>Doctor Share (Combined)</th>

                      <th>Settled Amount (Cash)</th>
                      <th>Glamyo Share (Cash)</th>
                      <th>Hospital Share (Cash)</th>
                      <th>Doctor Share (Cash)</th>

                      <th>Settled Amount (Insurance)</th>
                      <th>Glamyo Share (Insurance)</th>
                      <th>Hospital Share (Insurance)</th>
                      <th>Doctor Share (Insurance)</th>
                    </tr>
                  </thead>
                  <tbody class="tbodycss">
                    <tr class="box overall" *ngFor="let paymentamt of PaymentsStats;">
                      <td>{{paymentamt.name}}</td>

                      <td>{{paymentamt.ipds_Insurancecount+paymentamt.ipds_Cashcount}}</td>
                      <td>{{paymentamt.ipds_Insurancecount}}</td>
                      <td>{{paymentamt.ipds_Cashcount}}</td>

                      <td>{{paymentamt.combinedAverage | number : '1.0-0'}}</td>
                      <td>{{paymentamt.InsuranceAverageCount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.CashAverageCount | number : '1.0-0'}}</td>

                      <td>{{paymentamt.InsuranceBilledAmount+paymentamt.CashBilledAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.InsuranceBilledAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.CashBilledAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.MouDiscountAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.CoPayAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.ConsumableAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.PaidAmountSum | number : '1.0-0'}}</td>

                      <td>{{paymentamt.SettledAmountSum | number : '1.0-0'}}</td>
                      <td>{{paymentamt.GlamyoShareSum | number : '1.0-0'}} ({{(paymentamt.GlamyoShareSum)?(paymentamt.GlamyoShareSum * 100 / paymentamt.SettledAmountSum | number : '1.0-0'):'0'}}%)</td>
                      <td>{{paymentamt.HospitalShareSum | number : '1.0-0'}} ({{(paymentamt.HospitalShareSum)?(paymentamt.HospitalShareSum * 100 / paymentamt.SettledAmountSum | number : '1.0-0'):'0'}}%)</td>
                      <td>{{paymentamt.DoctorShareSum | number : '1.0-0'}} ({{(paymentamt.DoctorShareSum)?(paymentamt.DoctorShareSum * 100 / paymentamt.SettledAmountSum | number : '1.0-0'):'0'}}%)</td>

                      <td>{{paymentamt.CashSettledAmountSum | number : '1.0-0'}}</td>
                      <td>{{paymentamt.CashGlamyoShareSum | number : '1.0-0'}} ({{(paymentamt.CashGlamyoShareSum)?(paymentamt.CashGlamyoShareSum * 100 / paymentamt.CashSettledAmountSum | number : '1.0-0'):'0'}}%)</td>
                      <td>{{paymentamt.CashHospitalShareSum | number : '1.0-0'}} ({{(paymentamt.CashHospitalShareSum)?(paymentamt.CashHospitalShareSum * 100 / paymentamt.CashSettledAmountSum | number : '1.0-0'):'0'}}%)</td>
                      <td>{{paymentamt.CashDoctorShareSum | number : '1.0-0'}} ({{(paymentamt.CashDoctorShareSum)?(paymentamt.CashDoctorShareSum * 100 / paymentamt.CashSettledAmountSum | number : '1.0-0'):'0'}}%)</td>

                      <td>{{paymentamt.InsuranceSettledAmountSum | number : '1.0-0'}}</td>
                      <td>{{paymentamt.InsuranceGlamyoShareSum | number : '1.0-0'}} ({{(paymentamt.InsuranceGlamyoShareSum)?(paymentamt.InsuranceGlamyoShareSum * 100 / paymentamt.InsuranceSettledAmountSum | number : '1.0-0'):'0'}}%)</td>
                      <td>{{paymentamt.InsuranceHospitalShareSum | number : '1.0-0'}}({{(paymentamt.InsuranceHospitalShareSum)?(paymentamt.InsuranceHospitalShareSum * 100 / paymentamt.InsuranceSettledAmountSum | number : '1.0-0'):'0'}}%) </td>
                      <td>{{paymentamt.InsuranceDoctorShareSum | number : '1.0-0'}} ({{(paymentamt.InsuranceDoctorShareSum)?(paymentamt.InsuranceDoctorShareSum * 100 / paymentamt.InsuranceSettledAmountSum | number : '1.0-0'):'0'}}%)</td>


                    </tr>


                    <tr *ngIf="Paymentloading">
                      <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Payment Stats Catergory Wise-->
        <div class="row row-cards" *ngIf="myrole=='1' || (myrole=='3' && cm_access == '1')">
          <div class="col-sm-12 col-lg-12 pr-0 pl-0 mt-2 float-left">
            <h2>Payment Stats Catergory Wise</h2>
            <div class="row ">
              <div class="row col-sm-12">
                <div class="col-sm-6">
                  <mat-form-field appearance="fill">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate #dateRangeStart6 placeholder="Start date">
                        <input matEndDate #dateRangeEnd6 placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart6, dateRangeEnd6,6)">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                  </mat-form-field>
                  <mat-icon (click)="clearDate(6)">clear</mat-icon>
                </div>
                <!-- <div class="col-sm-4">
                  <mat-select placeholder="Select Treatment Catergory" [(ngModel)]="treatment_catergory" (selectionChange)="getPaymentsStats()">
                    <mat-option >All</mat-option>
                    <mat-option value="{{tc.id}}" *ngFor="let tc of treatCategory">{{tc.name}}</mat-option>
                  </mat-select>
                </div> -->
             
              </div>
            </div>
            <div class="card">
              <div class="table-responsive">
                <table class="table table-hover table-bordered table-vcenter text-nowrap card-table">
                  <thead>
                    <tr>
                      <th class="thstyle">Particulars</th>
                      <th class="thstyle" colspan="3">Ipd Count</th>
                      <th class="thstyle" colspan="3">ATS</th>
                      <th class="thstyle" colspan="7">Billing</th>
                      <th class="thstyle" colspan="12">Net IPD Revenue</th>
                    </tr>
                  </thead>
                  <thead>
                    <tr>
                      <th></th>

                      <th>Combined</th>
                      <th>Insurance</th>
                      <th>Cash/EMI</th>

                      <th>Combined</th>
                      <th>Insurance</th>
                      <th>Cash</th>

                      <th>Gross Bill</th>
                      <th>Insurance</th>
                      <th>Cash/EMI</th>
                      <th>MOU Discount</th>
                      <th>Co Pay</th>
                      <th>Consumable</th>
                      <th>Patient Paid</th>

                      <th>Settled Amount (Combined)</th>
                      <th>Glamyo Share (Combined)</th>
                      <th>Hospital Share (Combined)</th>
                      <th>Doctor Share (Combined)</th>

                      <th>Settled Amount (Cash)</th>
                      <th>Glamyo Share (Cash)</th>
                      <th>Hospital Share (Cash)</th>
                      <th>Doctor Share (Cash)</th>

                      <th>Settled Amount (Insurance)</th>
                      <th>Glamyo Share (Insurance)</th>
                      <th>Hospital Share (Insurance)</th>
                      <th>Doctor Share (Insurance)</th>
                    </tr>
                  </thead>
                  <tbody class="tbodycss">
                    <tr class="box overall" *ngFor="let paymentamt of CatergoryPaymentsStats;">
                      <td>{{paymentamt.name}}</td>

                      <td>{{paymentamt.ipds_Insurancecount+paymentamt.ipds_Cashcount}}</td>
                      <td>{{paymentamt.ipds_Insurancecount}}</td>
                      <td>{{paymentamt.ipds_Cashcount}}</td>

                      <td>{{paymentamt.combinedAverage | number : '1.0-0'}}</td>
                      <td>{{paymentamt.InsuranceAverageCount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.CashAverageCount | number : '1.0-0'}}</td>

                      <td>{{paymentamt.InsuranceBilledAmount+paymentamt.CashBilledAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.InsuranceBilledAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.CashBilledAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.MouDiscountAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.CoPayAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.ConsumableAmount | number : '1.0-0'}}</td>
                      <td>{{paymentamt.PaidAmountSum | number : '1.0-0'}}</td>

                      <td>{{paymentamt.SettledAmountSum | number : '1.0-0'}}</td>
                      <td>{{paymentamt.GlamyoShareSum | number : '1.0-0'}} ({{(paymentamt.GlamyoShareSum)?(paymentamt.GlamyoShareSum * 100 / paymentamt.SettledAmountSum | number : '1.0-0'):'0'}}%)</td>
                      <td>{{paymentamt.HospitalShareSum | number : '1.0-0'}} ({{(paymentamt.HospitalShareSum)?(paymentamt.HospitalShareSum * 100 / paymentamt.SettledAmountSum | number : '1.0-0'):'0'}}%)</td>
                      <td>{{paymentamt.DoctorShareSum | number : '1.0-0'}} ({{(paymentamt.DoctorShareSum)?(paymentamt.DoctorShareSum * 100 / paymentamt.SettledAmountSum | number : '1.0-0'):'0'}}%)</td>

                      <td>{{paymentamt.CashSettledAmountSum | number : '1.0-0'}}</td>
                      <td>{{paymentamt.CashGlamyoShareSum | number : '1.0-0'}} ({{(paymentamt.CashGlamyoShareSum)?(paymentamt.CashGlamyoShareSum * 100 / paymentamt.CashSettledAmountSum | number : '1.0-0'):'0'}}%)</td>
                      <td>{{paymentamt.CashHospitalShareSum | number : '1.0-0'}} ({{(paymentamt.CashHospitalShareSum)?(paymentamt.CashHospitalShareSum * 100 / paymentamt.CashSettledAmountSum | number : '1.0-0'):'0'}}%)</td>
                      <td>{{paymentamt.CashDoctorShareSum | number : '1.0-0'}} ({{(paymentamt.CashDoctorShareSum)?(paymentamt.CashDoctorShareSum * 100 / paymentamt.CashSettledAmountSum | number : '1.0-0'):'0'}}%)</td>

                      <td>{{paymentamt.InsuranceSettledAmountSum | number : '1.0-0'}}</td>
                      <td>{{paymentamt.InsuranceGlamyoShareSum | number : '1.0-0'}} ({{(paymentamt.InsuranceGlamyoShareSum)?(paymentamt.InsuranceGlamyoShareSum * 100 / paymentamt.InsuranceSettledAmountSum | number : '1.0-0'):'0'}}%)</td>
                      <td>{{paymentamt.InsuranceHospitalShareSum | number : '1.0-0'}}({{(paymentamt.InsuranceHospitalShareSum)?(paymentamt.InsuranceHospitalShareSum * 100 / paymentamt.InsuranceSettledAmountSum | number : '1.0-0'):'0'}}%) </td>
                      <td>{{paymentamt.InsuranceDoctorShareSum | number : '1.0-0'}} ({{(paymentamt.InsuranceDoctorShareSum)?(paymentamt.InsuranceDoctorShareSum * 100 / paymentamt.InsuranceSettledAmountSum | number : '1.0-0'):'0'}}%)</td>


                    </tr>


                    <tr *ngIf="CatergoryPaymentloading">
                      <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>


        <!-- Lead stats -->
        <div class="row row-cards" *ngIf="myrole=='3' || myrole=='1' || myrole=='6' || myrole=='7' || myrole=='18'" style="display: none;">
              <div class="col-sm-6" *ngIf="myrole!='6'">
                  <h2>User wise Leads</h2>
                  <div class=' card p-0' style="height: 510px; overflow: scroll;">
                    <table class="table table-hover table-outline table-vcenter dashtable">
                          <thead>
                              <tr>
                                  <th></th>
                                  <th>Users</th>
                                  <th class="text-center">Total Lead Count</th>
                              </tr>
                          </thead>
                          <tbody>
                            <tr class="box overall" [ngClass]="{'bg-red-lighter':user.id==21}" *ngFor="let user of allUsers">
                                <td class="text-center">
                                    <div class="avatar d-block" style="background-image: url('https://glamyohealth.in/backend/assets/backend/img/static/admin-avatar.png')">
                                      <span class="avatar-status bg-green"></span>
                                    </div>
                                  </td>
                                  <td>{{user.name}}</td>
                                  <td class="text-center"><span class="avatar avatar-md avatar-rounded text-white bg-success">{{user.lead_count}}</span></td>
                              </tr>
                              <tr class="box overall" *ngIf="loadingU">
                                  <td colspan="3" class="text-center"><i class="fas fa-spin fa-spinner fa-2x"></i></td>
                              </tr>
                              <tr class="box overall" *ngIf="loaded && !allUsers.length">
                                  <td colspan="3" class="text-center"> <i class="far fa-frown"></i> No Leads Available</td>
                              </tr>
                          </tbody>
                    </table>
                  </div>
              </div>
              <div class="col-sm-6" *ngIf="myrole=='1' || myrole=='6' || myrole=='7' || myrole=='18'">
                  <h2>Circle wise Leads</h2>
                  <div class='card p-0' style="height: 510px; overflow: scroll;">
                      <table class="table table-hover table-outline table-vcenter dashtable">
                            <thead>
                                <tr>
                                    <th class="text-center">Circle</th>
                                    <th class="text-center">Zoho</th>
                                    <th class="text-center">Kalyera</th>
                                </tr>
                            </thead>
                            <tbody>
                              <tr class="box overall" [ngClass]="{'bg-red-lighter':circle.id==5}" *ngFor="let circle of circles">
                                  <td class="text-center">
                                      {{circle.name}}
                                    </td>
                                    <td class="text-center"><span class="avatar avatar-md text-white bg-primary">{{circle.zoho}}</span></td>
                                    <td class="text-center"><span class="avatar avatar-md  text-white bg-success">{{circle.kaleyra}}</span></td>
                                </tr>
                                <tr class="box overall" *ngIf="loadingC">
                                    <td colspan="3" class="text-center"><i class="fas fa-spin fa-spinner fa-2x"></i></td>
                                </tr>
                            </tbody>
                      </table>
                  </div>
              </div>
          </div>
     <!-- lead stats end -->
    </div>
</div>
